import * as React from 'react';

import AvatarWithText from 'components/AvatarWithText';
import BoxBody from 'components/BoxBody';
import Button from 'components/ButtonDeprecated';
import Dialog from 'components/Dialog';
import FormElement from 'components/FormElement';
import GroupAvatar from 'groups/components/GroupAvatar';
import Input from 'components/Input';
import Row from 'components/Row';
import Text from 'components/Text';
import Group from 'entities/Group';

import './styles/GroupRequestApprovalModal.scss';

type Props = {
  classToRequest: Group;
  classRequestButtonEnabled: boolean;
  orgName: string;
  onChange: (reasonText: string) => void;
  onClickCancel: () => void;
  onRequestHide: () => void;
  onSubmit: () => void;
  selectedAvatarUrl: string;
  classAction: 'create' | 'edit' | 'unarchive';
};

const GroupRequestApprovalModal = (props: Props) => {
  const {
    classToRequest,
    classRequestButtonEnabled,
    orgName,
    onChange,
    onClickCancel,
    onRequestHide,
    onSubmit,
    selectedAvatarUrl,
    classAction,
  } = props;
  const classCode = classToRequest?.getCode();
  const className = classToRequest?.getName();

  return (
    <Dialog
      className="GroupRequestApprovalModal"
      title="Request approval"
      size="small"
      onRequestHide={onRequestHide}
      onDialogDismiss={onClickCancel}
    >
      <BoxBody>
        {/* Render class card */}
        <Row>
          <div className="GroupRequestApprovalModal-classCard">
            <AvatarWithText
              avatar={
                <GroupAvatar
                  group={{
                    groupAvatar: { svg_url: selectedAvatarUrl },
                  }}
                />
              }
              gutter="medium"
              subtext={classCode ? `@${classCode}` : ''}
              title={className}
            />
          </div>
        </Row>

        <Text element="p" align="left">
          {classAction === 'create' && (
            <>
              You'll need administrator approval to create this class since you aren't an approved
              teacher at <b>{orgName}</b>.
            </>
          )}
          {classAction === 'edit' && (
            <>
              You'll need administrator approval to use this class if you connect it to{' '}
              <b>{orgName}</b> since you aren't an approved teacher there.
            </>
          )}
          {classAction === 'unarchive' && (
            <>
              You'll need administrator approval to use this class if you unarchive it because you
              aren't an approved teacher at <b>{orgName}</b>.
            </>
          )}
        </Text>

        <FormElement
          label="Class purpose"
          validate={(e) => {
            const requestReasonText = e.target.value.trim();
            onChange(requestReasonText);
          }}
          element={Input}
          elementProps={{
            required: true,
            autofocus: true,
            placeholder: 'Coordinating soccer team carpools',
          }}
        />
        <Button
          full
          disabled={!classRequestButtonEnabled}
          onClick={onSubmit}
          data-test-selector="group-create-modal-submit-class-create-request"
        >
          Request to {classAction === 'create' ? 'create' : 'connect'} class
        </Button>
        <Button full color="whiteout" onClick={onClickCancel}>
          {classAction === 'create' ? 'Go back' : 'Cancel'}
        </Button>
      </BoxBody>
    </Dialog>
  );
};

export default GroupRequestApprovalModal;
